require('./bootstrap');

//app
require('./admin/alpine');
require('./admin/general');
require('./admin/mousetrap');
require('./admin/copy');
